import { notificationError } from "../services/notification";

export enum DownloadBlobConfigBehavior {
  OPEN_IN_NEW_WINDOW,
  DIRECT_DOWNLOAD,
}

export type DownloadBlobConfig = {
  name: string;
  behavior: DownloadBlobConfigBehavior;
};

export const isBlob = (data: any): data is Blob => {
  return data instanceof Blob;
};

export const openInNewWindow = (blob: Blob) => {
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    URL.revokeObjectURL(url);
};

export const directDownload = (name: string, blob: Blob) => {
  const a = document.createElement("a");
  const downloadURL = URL.createObjectURL(blob);
  const extension = blob.type.split("/").pop();

  a.target = "_blank";
  a.download = `${name}.${extension}`;
  a.href = downloadURL;
  a.click();

  URL.revokeObjectURL(downloadURL);
  a.remove();
};

export const downloadBlob = (blob: Blob, config: DownloadBlobConfig) => {
  try {
    const { name, behavior } = config;

    if (behavior === DownloadBlobConfigBehavior.DIRECT_DOWNLOAD) {
      directDownload(name, blob);
    }

    if (behavior === DownloadBlobConfigBehavior.OPEN_IN_NEW_WINDOW) {
      openInNewWindow(blob);
    }
  } catch (e) {
    notificationError(`DownloadBlob Error:  ${e}`);
  }
};

export const exportCsv = (res: string, name?:string) => {
  //var uri = "data:text/csv;charset=utf-8," + escape(res)

  const blob = new Blob(["\ufeff"+res], { type: 'text/csv;charset=utf-8' });
  var downloadLink = document.createElement("a");
  //downloadLink.href = uri;
  downloadLink.href = window.URL.createObjectURL(blob);
  downloadLink.target = "_blank";
  downloadLink.download = name+".csv";

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  //window.open("data:text/csv;charset=utf-8," + escape(res), "name:name");
};

function s2ab(s: string) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}
export const exportXls = (res: string, name:string) => {
  //var uri = "data:text/csv;charset=utf-8," + escape(res)
  const blob = new Blob([s2ab(atob(res))], { type: 'application/xls' });
  downloadBlob(blob, {
    name: name,
    behavior: DownloadBlobConfigBehavior.DIRECT_DOWNLOAD,
  });
};

export const exportPdf = async (
  name: string,
  blob: Blob,
  behavior: DownloadBlobConfigBehavior = DownloadBlobConfigBehavior.DIRECT_DOWNLOAD
) => {
  downloadBlob(blob, {
    name,
    behavior,
  });
};
